import React from 'react'
import { View } from 'oio-react'
import { PrivacyGlyphIcon24, RoleIcon } from 'assets/icons'
import { settingsUrl, settingsPeopleUrl } from 'config/constants/urls'
import ProtoColumnNavButton from 'src/components/Settings/ProtoColumnNavButton'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization } from 'src/graphql/hooks'

const SettingsPeopleHome = () => {
   const { organization } = useOrganization()
   const roles = organization.roles.filter(r => r.type !== 'public')

   return (
      <View>
         <ProtoReturnBar
            display="block[a-b] none[c-f]"
            returnLinkName="Admin Workspace"
            returnLinkTo={settingsUrl}
         />
         <View>
            <View
               display="flex"
               justifyContent="center"
               width="100%">
               <View width="100%" maxWidth="90%[c] 480px[d]">
                  <View
                     float="left"
                     display="flex"
                     padding="40px 20px[a-b] 40px 0px[c-d] 40px 20px[e-f]">
                     <ProtoHeadingBlock
                        colorMode="light"
                        title="People, Privacy & Roles"
                        description="Manage who can see and join your Community. Invite new people to become Admins or Members of this Community."
                     />
                  </View>
                  <View
                     float="left"
                     width="100%"
                     backgroundColor="#fafafa"
                     padding="9px 0px[c-d]"
                     borderRadius="6px[c-d]"
                     borderTop="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]"
                     borderBottom="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]">
                     <ProtoColumnNavButton
                        borderStyle="none"
                        color="#222"
                        linkName="Site Privacy"
                        linkTo={`${settingsPeopleUrl}/privacy`}
                        icon={(
                           <PrivacyGlyphIcon24
                              className="icon"
                              width="16px"
                              height="16px"
                           />
                        )}
                     />
                     {roles.map((role, index) => (
                        <ProtoColumnNavButton
                           key={role.id}
                           color="#222"
                           linkName={`${role.name} (${role.numActiveUsers})`}
                           linkTo={`${settingsPeopleUrl}/role/${role.id}`}
                           icon={(
                              <RoleIcon
                                 className="icon"
                                 width="14px"
                                 height="14px"
                              />
                           )}
                        />
                     ))}
                  </View>
               </View>
            </View>
         </View>
      </View>
   )
}

export default SettingsPeopleHome
